var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"mt-4",attrs:{"row":"","wrap":""}},_vm._l((_vm.content),function(link,i){return _c('v-flex',{key:i,staticClass:"d-inline"},[_c('linkGreen',{staticClass:"mr-4",on:{"click":function($event){link.database_id ? _vm.modal_open_wrapper(link.database_id) : 'null'}}},[_vm._v(_vm._s(link.title))])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }